import React, { useState } from 'react';

import useEventWithDimensions from 'hooks/useEventWithDimensions';

import { CreateReportCard } from 'components/common/CreateReportCard/CreateReportCard';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { ProjectTree } from 'components/common/TreeProgramFilter/ProjectTree/ProjectTree';

import { CreateFromScratchReportModal } from 'components/Dashboards/Reporting/CreateFromScratchReportModal/CreateFromScratchReportModal';
import classes from 'components/pages/CreateReportPage/components/BuildNewReport/BuildNewReport.module.scss';
import { InitialTemplateCards } from 'components/widgets/ReportsHome/ReportsTemplates/components/InitialTemplateCards/InitialTemplateCards';

const START_FROM_SCRATCH_CARD_DETAILS =
    'Start with a blank canvas and customize your report from the ground up. Perfect for unique reporting needs.';

export const BuildNewReport = () => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const { sendEventWithDimensions } = useEventWithDimensions();

    const handleClick = (): void => {
        sendEventWithDimensions({
            category: 'Reporting',
            action: 'Create from Scratch Selected',
            label: 'none',
        });
        setIsModalOpen(true);
    };

    return (
        <div className={classes.buildNewReportWrapper}>
            <div className={classes.projectContractSelectionWrapper}>
                <div className={classes.subTitle}>Select initial schedule data:</div>
                <ProjectTree />
            </div>

            <div className={classes.reportCreationMethodsWrapper}>
                <CreateReportCard
                    title={'Custom Report'}
                    details={START_FROM_SCRATCH_CARD_DETAILS}
                    actionButtonIcon={<MuiIcon icon={'add'} color={'var(--button-primary-fg)'} />}
                    actionButtonChildren={'Create report'}
                    onClick={handleClick}
                />
            </div>
            <InitialTemplateCards />

            {isModalOpen && <CreateFromScratchReportModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />}
        </div>
    );
};
